import Bus from '@client/events/bus';
import PlaidTypes from '@client/events/types/plaid';
import Context from '@client/events/context';
import store from '@client/store';
import {Logger, Category} from '@simpleinvest/front-end-logger';
import {displayErrorBanner} from '@client/events/notification-bus';

const logger = new Logger({
  category: Category.TransferMoney,
  fileName: 'plaid.js',
});

const {
  INCORRECT_DEPOSIT_AMOUNTS,
  TOO_MANY_VERIFICATION_ATTEMPTS,
  ACCOUNTS_LIMIT,
  ADDITION_LIMIT,
  AUTH_LIMIT,
  IDENTITY_LIMIT,
  INCOME_LIMIT,
  ITEM_GET_LIMIT,
  RATE_LIMIT,
  TRANSACTIONS_LIMIT,
} = PlaidTypes;

const rateLimitEvents = [
  ACCOUNTS_LIMIT,
  ADDITION_LIMIT,
  AUTH_LIMIT,
  IDENTITY_LIMIT,
  INCOME_LIMIT,
  ITEM_GET_LIMIT,
  RATE_LIMIT,
  TRANSACTIONS_LIMIT,
];

export const notify = (text) => {
  displayErrorBanner(text);
};

export const logException = (context) => {
  const {error} = context.meta;

  logger.addBreadcrumb({
    callingFuncName: context.caller,
    message: error.error_message,
  });
  logger.logMessage({
    message: `${JSON.stringify(context)} ${JSON.stringify(store.getters['transfers/plaidMetadata'])}`,
    level: 'warning',
  });
};

export default {
  register() {
    // TODO: Do we need to handle INVALID_LINK_TOKEN errors since we're creating a new instance of Link each time?

    Bus.$on([INCORRECT_DEPOSIT_AMOUNTS, TOO_MANY_VERIFICATION_ATTEMPTS], async (payload) => {
      if (!(payload instanceof Context)) {
        return;
      }

      const {microDeposit, error} = payload.meta;

      if (!microDeposit) {
        return;
      }

      notify(
        'We are unable to verify this bank link at this time. Any connected transfers to this bank have been canceled. Please try linking your bank again.'
      );

      await store.dispatch('movemoney/cancelMicroDeposit', {
        microDepositId: microDeposit.micro_deposit_id,
        error: JSON.stringify(error),
      });
    });

    Bus.$on(rateLimitEvents, (payload) => {
      if (!(payload instanceof Context)) {
        return;
      }

      notify('Too many requests. Please try again after some time.');
    });

    // This is the generic error logged if plaid throws any error. It could also throw a specific one
    Bus.$on('GENERIC_PLAID_ERROR', (payload) => {
      logException(payload);
    });
  },
};
